// Step 4: Campaign Review & Scheduling - Alpine.js Component
// Handles collapsible tactic sections and campaign scheduling

document.addEventListener('alpine:init', () => {
  Alpine.data('campaigns_step4_x_data', () => ({
    showModal: false,
    expandedTactics: [], // Track which tactics are expanded
    campaignConfirmed: false, // Track campaign confirmation checkbox
    scheduleError: null, // Track scheduling error messages
    scheduleSuccess: null, // Track scheduling success messages
    isScheduling: false, // Track scheduling loading state
    
    // Toggle tactic expansion
    toggleTactic(tacticId) {
      const index = this.expandedTactics.indexOf(tacticId);
      if (index > -1) {
        // Remove from expanded list
        this.expandedTactics.splice(index, 1);
      } else {
        // Add to expanded list
        this.expandedTactics.push(tacticId);
      }
    },
    
    // Expand all tactics
    expandAllTactics() {
      // Get all tactic IDs from the page
      const tacticElements = document.querySelectorAll('[data-tactic-id]');
      this.expandedTactics = Array.from(tacticElements).map(el => el.dataset.tacticId);
    },
    
    // Collapse all tactics
    collapseAllTactics() {
      this.expandedTactics = [];
    },
    
    // Save draft functionality
    async saveDraft() {
      try {
        const response = await fetch(`/shows/${this.getShowId()}/campaigns/${this.getCampaignId()}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.getCsrfToken()
          },
          body: JSON.stringify({
            campaign: {
              
            },
            draft: 'true'
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.status === 'draft_saved') {
          // Redirect to campaigns index using URL from template
          try {
            const template = this.$refs.js_data;
            console.log('Template element:', template);
            
            if (template && template.dataset && template.dataset.campaignsIndexUrl) {
              const campaignsIndexUrl = template.dataset.campaignsIndexUrl;
              console.log('Redirecting to:', campaignsIndexUrl);
              window.location.href = campaignsIndexUrl;
            } else {
              console.error('Template or dataset not found, using fallback');
              // Fallback to manual construction
              const fallbackUrl = `/shows/${this.getShowId()}/campaigns`;
              console.log('Using fallback URL:', fallbackUrl);
              window.location.href = fallbackUrl;
            }
          } catch (templateError) {
            console.error('Error accessing template:', templateError);
            // Fallback to manual construction
            const fallbackUrl = `/shows/${this.getShowId()}/campaigns`;
            console.log('Using fallback URL due to template error:', fallbackUrl);
            window.location.href = fallbackUrl;
          }
        } else {
          console.error('Failed to save draft:', result);
          // Could add inline error message here if needed
        }
      } catch (error) {
        console.error('Error saving draft:', error);
        // Could add inline error message here if needed
      }
    },

    // Confirm action (schedule campaign)
    confirmAction() {
      // Here you would implement the actual campaign scheduling logic
      this.scheduleSuccess = 'Campaign scheduled successfully!';
      this.showModal = false;
      // Redirect or show success message
    },

    // Confirm schedule from modal
    confirmSchedule() {
      if (!this.campaignConfirmed) {
        // Show inline error message instead of alert
        this.scheduleError = 'Please confirm your campaign details first.';
        return;
      }
      
      // Clear any previous error messages
      this.scheduleError = null;
      
      // Get the schedule route from the hidden div in the modal
      const routesDiv = document.querySelector('[x-ref="routes"]');
      if (!routesDiv) {
        console.error('Routes div not found');
        this.scheduleError = 'Configuration error. Please refresh the page and try again.';
        return;
      }
      
      const scheduleLink = routesDiv.dataset.scheduleLink;
      if (!scheduleLink) {
        console.error('Schedule route not found');
        this.scheduleError = 'Configuration error. Please refresh the page and try again.';
        return;
      }
      
      // Show loading state
      this.isScheduling = true;
      
      // Make the API call to schedule the campaign
      fetch(scheduleLink, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCsrfToken()
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          // Show success message and redirect
          this.scheduleSuccess = data.message || 'Campaign scheduled successfully!';
          // Redirect to campaigns list after a brief delay
          setTimeout(() => {
            const campaignsIndexUrl = `/shows/${this.getShowId()}/campaigns`;
            window.location.href = campaignsIndexUrl;
          }, 1500);
        } else {
          this.scheduleError = data.message || 'Failed to schedule campaign.';
        }
      })
      .catch(error => {
        console.error('Error scheduling campaign:', error);
        this.scheduleError = 'Error scheduling campaign. Please try again.';
      })
      .finally(() => {
        this.isScheduling = false;
      });
    },

    // Utility methods
    getShowId() {
      const path = window.location.pathname;
      const match = path.match(/\/shows\/([^\/]+)/);
      return match ? match[1] : null;
    },

    getCampaignId() {
      const path = window.location.pathname;
      const match = path.match(/\/campaigns\/([^\/]+)/);
      return match ? match[1] : null;
    },

    getCsrfToken() {
      return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    }
  }));
});
